/**
 * static/js/utils/list-row.js
 *
 * Canonical list row for JS-rendered lists (topics / social / languages /
 * services). Mirrors templates/_components/list_row.html and reuses
 * JN.actionMenu for the trailing kebab. Load AFTER action-menu.js.
 *
 * Usage (drop-in replacement for the bespoke renderTableRow helpers):
 *   $('#topics').append(JN.listRow.html({
 *     icon:  'iconoir:graduation-cap',          // OR initials: 'GK'
 *     title: skillName,
 *     meta:  '',                                // optional second line
 *     badge: '',                                // optional green status pill
 *     dataAttr: { 'skill-id': skillId },        // becomes data-skill-id="…"
 *     actions: [
 *       { label: 'Edit',   onclick: "editTopic('" + skillId + "')" },
 *       { label: 'Delete', onclick: "deleteTopic('" + skillId + "')", danger: true },
 *     ],
 *   }));
 *
 * Caller passes plain text / already-escaped values, as the old helpers did.
 */
(function (window, document) {
  'use strict';

  function esc(v) { return String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }

  function html(row) {
    var chip = row.initials
      ? '<span class="list-row-chip list-row-chip--photo">' + row.initials + '</span>'
      : '<span class="list-row-chip"><iconify-icon icon="' + esc(row.icon) + '"></iconify-icon></span>';

    var badge = row.badge
      ? '<span class="list-row-badge"><iconify-icon icon="mdi:check-circle" class="tw-text-sm"></iconify-icon>' + row.badge + '</span>'
      : '';

    var meta = row.meta ? '<div class="list-row-meta">' + row.meta + '</div>' : '';

    var menu = (row.actions && row.actions.length) ? JN.actionMenu.html(row.actions) : '';

    var data = '';
    if (row.dataAttr) {
      Object.keys(row.dataAttr).forEach(function (k) {
        data += ' data-' + k + '="' + esc(row.dataAttr[k]) + '"';
      });
    }

    return (
      '<div class="list-row"' + data + '>' +
        '<div class="list-row-main">' + chip +
          '<div class="list-row-body">' +
            '<div class="tw-flex tw-items-center tw-gap-2">' +
              '<span class="list-row-title">' + row.title + '</span>' + badge +
            '</div>' + meta +
          '</div>' +
        '</div>' + menu +
      '</div>'
    );
  }

  window.JN = window.JN || {};
  window.JN.listRow = { html: html };
})(window, document);
